/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Remove_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Remove selected style guide" |
*
* @param {Style_Guide_Manager_Remove_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_remove_aria_label = /** @type {((inputs?: Style_Guide_Manager_Remove_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Remove_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le guide de style selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählten Styleguide entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi la guida di stile selezionata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранную направляющую стиля")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar la guía de estilo seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除选定的样式指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したスタイルガイドを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित स्टाइल गाइड को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover guia de estilo selecionado")
	return /** @type {LocalizedString} */ ("Remove selected style guide")
});